import React from 'react';
import Image from 'next/image';
import { useGlobalStore } from '@/store';
import { LENDER_MAPPING } from '@/constants';
import { getEmiInterestAmount, roundToTwo } from '@/utils/helpers';
import { LENDER_NAMES } from '@/api/types';

const PlanDescription = (): JSX.Element => {
  const { selectedTenure, paymentDetails } = useGlobalStore();
  const { amount } = paymentDetails.data ?? {};
  return (
    <div data-testid="selected-plan">
      {selectedTenure ? (
        <div className="border border-opacity-18 border-outline-grey-muted rounded-lg">
          <div className="flex items-center px-3 py-2.5 ">
            <div className="border-surface-neutral-faded border w-fit p-1 rounded-full border-opacity-18 mr-2">
              <Image
                width={15}
                height={15}
                alt={selectedTenure.provider}
                src={`/${selectedTenure.provider}.svg`}
              />
            </div>
            <p className="text-on-grey-normal text-base">
              {LENDER_MAPPING[selectedTenure.provider as LENDER_NAMES]}
            </p>
          </div>
          <div className="pt-3.5 flex justify-center bg-surface-grey-moderate">
            <div className="flex w-full justify-around mb-4">
              <div>
                <p className="text-on-grey-muted text-sm text-opacity-60">EMI</p>
                <p className="text-on-grey-normal">₹{selectedTenure.amount}</p>
              </div>
              <div>
                <p className="text-on-grey-muted text-sm text-opacity-60">Tenure</p>
                <p className="text-on-grey-normal">{selectedTenure.tenure} months</p>
              </div>
              <div>
                <p className="text-on-grey-muted text-sm text-opacity-60">Interest</p>
                <p className="text-on-grey-normal">
                  ₹
                  {selectedTenure.total_interest_amount
                    ? roundToTwo(selectedTenure.total_interest_amount)
                    : 0}
                </p>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default PlanDescription;
